import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTranslateImageToEnglishConfig } from '@/data/landingConfig/landingTranslateImageToEnglishConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TranslateImageToEnglish } from './schemaObject';

interface Props {}
const TranslateImageToEnglish: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TranslateImageToEnglish} />
			<LandingTemplate
				data={landingTranslateImageToEnglishConfig}
				funnelLinkService={GenerateLandingLinkService.funnelAiImageTranslator()}
			/>
		</>
	);
};

export default TranslateImageToEnglish;
